// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Environment info banner ────────────────────────────────────────────── */

.MMHGwsE856B3gKMMW6E_ {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 12px;
    padding: 12px 14px;
    border: 1px solid var(--curio-border);
    border-radius: var(--curio-radius-md);
    background: var(--curio-card-bg);
    margin-bottom: 8px;
    font-family: var(--curio-font-family);
}

.fFC8npZkY0GeiH4500qi {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: var(--curio-role-published-fg);
    color: var(--curio-text-on-dark);
    font-size: var(--curio-font-size-xs);
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;
}

.Lb94AWZrGR9c2Gk4vaoa {
    margin: 0 0 4px;
    font-size: var(--curio-font-size-md);
    font-weight: 600;
    color: var(--curio-text-primary);
}

.NQxxNS3t7114ShymfQul {
    margin: 0;
    font-size: var(--curio-font-size-sm);
    color: var(--curio-text-secondary);
    line-height: 1.45;
}
`, "",{"version":3,"sources":["webpack://./src/components/packages/publishing/EnvNote.module.css"],"names":[],"mappings":"AAAA,8EAA8E;;AAE9E;IACI,aAAa;IACb,+BAA+B;IAC/B,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC,qCAAqC;IACrC,gCAAgC;IAChC,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,gCAAgC;IAChC,oCAAoC;IACpC,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,oCAAoC;IACpC,kCAAkC;IAClC,iBAAiB;AACrB","sourcesContent":["/* ── Environment info banner ────────────────────────────────────────────── */\n\n.envNote {\n    display: grid;\n    grid-template-columns: auto 1fr;\n    gap: 12px;\n    padding: 12px 14px;\n    border: 1px solid var(--curio-border);\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-card-bg);\n    margin-bottom: 8px;\n    font-family: var(--curio-font-family);\n}\n\n.envIcon {\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    background: var(--curio-role-published-fg);\n    color: var(--curio-text-on-dark);\n    font-size: var(--curio-font-size-xs);\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    margin-top: 2px;\n}\n\n.envTitle {\n    margin: 0 0 4px;\n    font-size: var(--curio-font-size-md);\n    font-weight: 600;\n    color: var(--curio-text-primary);\n}\n\n.envText {\n    margin: 0;\n    font-size: var(--curio-font-size-sm);\n    color: var(--curio-text-secondary);\n    line-height: 1.45;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"envNote": `MMHGwsE856B3gKMMW6E_`,
	"envIcon": `fFC8npZkY0GeiH4500qi`,
	"envTitle": `Lb94AWZrGR9c2Gk4vaoa`,
	"envText": `NQxxNS3t7114ShymfQul`
};
export default ___CSS_LOADER_EXPORT___;
